export default __webpack_public_path__ + "static/media/kitchen4-afterA-1024w.ea40c64b.avif";